<template lang="pug">
base-section
  base-heading(title='404')
  base-subheading.text-primary(title='Oh!')
  base-subheading(space='8', title='Looks like this page doesn\'t exist')
  v-row(justify='center')
    v-col(cols=5)
      base-img.mx-auto.mb-12(
        :src='logoSrc',
        contain='',
        max-width='128',
        min-height='78',
        width='100%'
      )
  .text-center
    base-btn(href='/') Get me Out of Here
</template>

<script setup>
defineOptions({
  name: 'FourOhFour',
})

provide('heading', { align: 'center' })
const logoSrc = '/media/brand/icon-square-white.png'
</script>
